/**
 * PCM Faux Chat Widget
 *
 * The simulated chat bubble shown before the real Zendesk/Zopim widget has
 * loaded (or while it's still gathering consent) - lets a visitor type a
 * message, then hands off to the real widget via `window.pcmShowZopimChat`
 * (see zopim-chat-api.js, which must be enqueued first).
 */
(function(window, $) {
  'use strict';

  function autosizeChatTextarea(textarea) {
    textarea.style.height = 'auto';
    textarea.style.height = Math.max(textarea.scrollHeight, 40) + 'px';
  }

  window.modalChatText = function(parent, message) {
    const $messageBox = $(parent).find('.modal-fauxchat-window-message-text').first();
    const indicatorHtml = '<div class="typing-indicator"><span></span><span></span><span></span></div>';

    if (!$messageBox.length) {
      return;
    }

    $messageBox.html(indicatorHtml);

    window.setTimeout(function() {
      $messageBox.fadeOut(220, function() {
        $messageBox.html(message).fadeIn(220);
      });
    }, 700);
  };

  // Production's GA4 event for a chat started from one of these prompts
  // (pcm_conversionEventGA4('chat-message', null, 'chat') in its scripts.js):
  // the 'conversion' event and parameters pcm-forms.js sends per form field,
  // so GA4 reports keyed on form_field keep working. gtag only exists on the
  // production host (inc/enqueues.php).
  function trackChatMessage($el) {
    if (typeof window.gtag !== 'function') {
      return;
    }

    const $form = $el.closest('form');

    window.gtag('event', 'conversion', {
      form_page: window.location.pathname,
      form_field: 'chat-message',
      form_type: $el.closest('.pcm-popup-wrapper, .popup').length ? 'popup' : 'page',
      form_step: 'chat',
      form_id: $form.attr('id') || '',
      industry: $form.find('[name="industry"]').val() || ''
    });
  }

  function sendFauxChatMessage($chat) {
    if ($chat.hasClass('modal-fauxchat--sent')) {
      return;
    }

    const $textarea = $chat.find('.modal-fauxchat-textarea').first();
    const message = $.trim($textarea.val());

    if (!message) {
      $chat.find('.modal-fauxchat-window-respond-to').first().text('Type a message to start a chat:');
      $textarea.trigger('focus');
      return;
    }

    if (typeof window.pcmShowZopimChat !== 'function' || !window.pcmShowZopimChat(message)) {
      $chat.find('.modal-fauxchat-window-respond-to').first().text('Chat could not open. Please try again or call us.');
      return;
    }

    $chat.addClass('modal-fauxchat--sent');
    document.documentElement.classList.add('pcm-chat-sent');
    trackChatMessage($chat);
    // landingpage-family.js finishes the unlock form when its chat step sends.
    $chat.trigger('pcm:fauxChatSent', [message]);
  }

  function initFauxChat() {
    // Like the legacy formSteps() handoff: send the visitor's reply once,
    // then finish this chat step using the form's existing thanks/redirect.
    $(document).on('pcm:fauxChatSent.pcmModalReply', '[data-pcm-chat-completes-form]', function() {
      const $form = $(this).closest('form');
      if (window.PCMForms && $form.length) {
        window.PCMForms.skipStep($form.attr('id'));
      }
    });

    // The callback confirmation's legacy Open Chat link is inserted after a
    // successful save. Use the shared loader so consent/loading delays don't
    // drop its introduction; its href remains the fallback when chat can't load.
    $(document).on('click.pcmLegacyChatOpen', '[data-pcm-chat-open]', function(event) {
      if (typeof window.pcmShowZopimChat === 'function'
        && window.pcmShowZopimChat($(this).attr('data-pcm-chat-message') || '')) {
        event.preventDefault();
      }
    });

    $(document).on('input.pcmLegacyFauxChat', '.modal-fauxchat-textarea', function() {
      autosizeChatTextarea(this);
    });

    $(document).on('keydown.pcmLegacyFauxChat', '.modal-fauxchat-textarea', function(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        sendFauxChatMessage($(this).closest('.modal-fauxchat'));
      }
    });

    $(document).on('click.pcmLegacyFauxChat', '.modal-fauxchat-send', function(event) {
      event.preventDefault();
      sendFauxChatMessage($(this).closest('.modal-fauxchat'));
    });

    // The link over the whole window only shows where there's no reply box -
    // production's phone chat bar on the landing pages - and a tap anywhere
    // on it opened the real chat window.
    $(document).on('click.pcmLegacyFauxChat', '.modal-fauxchat-window-link', function(event) {
      event.preventDefault();

      const $chat = $(this).closest('.modal-fauxchat');

      if ($chat.find('.modal-fauxchat-textarea').first().is(':visible')) {
        sendFauxChatMessage($chat);
        return;
      }

      window.pcmShowZopimChat('');
    });

    // A collapsible chat (the landing pages' phone bubble) folds back into
    // its bubble rather than going away.
    $(document).on('click.pcmLegacyFauxChat', '.modal-fauxchat-window-close-button', function(event) {
      event.preventDefault();

      const $chat = $(this).closest('.modal-fauxchat');

      if ($chat.is('[data-fauxchat-collapsible]')) {
        $chat.removeClass('is-open');
        return;
      }

      $chat.addClass('modal-fauxchat--closed').hide();
    });

    $(document).on('click.pcmLegacyFauxChat', '.modal-fauxchat-bubble', function(event) {
      event.preventDefault();
      $(this).closest('.modal-fauxchat').addClass('is-open');
    });

    // pcm-forms.js's "Start Chatting" ([data-trigger-chat]) talks to $zopim
    // itself and skips the chat when the widget hasn't loaded - in an opt-in
    // state, anyone who hasn't accepted cookies. That click asks for the
    // chat, so hand it to pcmShowZopimChat(), which loads the widget first.
    // With the widget already there the plugin sends it, so leave it be.
    $(document).on('chatTrigger.pcmLegacyFauxChat', 'form', function(event, data) {
      trackChatMessage($(this));

      if (typeof window.$zopim === 'function') {
        return;
      }

      document.documentElement.classList.add('pcm-chat-sent');
      window.pcmShowZopimChat(data && data.message ? data.message : '');
    });
  }

  if ($ && $.fn) {
    $(initFauxChat);
  }
})(window, window.jQuery);
